module.exports = __webpack_public_path__ + "static/img/h1.2a228c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h1.png
// module id = O4WM
// module chunks = 1